import { WSElement, WSTableCell } from "@wingspanhq/fe-component-library";
import { useQueryAllPayeeEngagements } from "../../../../query/payeeEngagements/queries/useQueryAllPayeeEngagements";

interface ContractorsCountCellProps {
  engagementId: string;
}

export function ContractorsCountCell({
  engagementId
}: ContractorsCountCellProps) {
  const queryEngagements = useQueryAllPayeeEngagements({
    filter: {
      engagementId
    },
    page: {
      size: 1
    }
  });

  return queryEngagements.isInitialLoading ? (
    <WSElement shimmer>Loading</WSElement>
  ) : (
    <WSTableCell text={`${queryEngagements.data?.summary.listSize ?? "-"}`} />
  );
}
